import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventType_Create, EventType_Update, LL_V_L, ProtoComponent } from '@nu-art/thunderstorm-frontend/index';
import './Panel_DPView_ContentSelector.scss';
import { DPView_VariablesAndValues } from '../../renderers/DPView_VariablesAndValues.js';
import { ModuleFE_DiseaseView } from '../../../_entity.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { Panel_MultiVarList } from '../Panel_MultiVarList/Panel_MultiVarList.js';
import { DBDef_DiseaseView, dpViewType_MultivarAndValuesList, dpViewType_MultivarList, noConnectedViewDPView } from '@app/dp-shared';
export class Panel_DPView_ContentSelector extends ProtoComponent {
    // ######################### Static #########################
    static defaultProps = {
        keys: ['selected'],
    };
    // ######################### Life Cycle #########################
    __onDiseaseViewUpdated(...params) {
        if ((params[0] === EventType_Update || params[0] === EventType_Create) && params[1]._id === this.state.selectedDiseaseViewId)
            this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state.selectedDiseaseViewId = this.getQueryParam('selected', {})[DBDef_DiseaseView.dbKey];
        return state;
    }
    // ######################### Render #########################
    renderPanelMain = () => {
        if (!this.state.selectedDiseaseViewId)
            return _jsx("div", { className: 'no-prop-message', children: "No Disease View Selected" });
        const selectedDiseaseView = this.state.selectedDiseaseViewId === noConnectedViewDPView._id
            ? noConnectedViewDPView
            : ModuleFE_DiseaseView.cache.unique(this.state.selectedDiseaseViewId);
        if (!selectedDiseaseView)
            throw new MUSTNeverHappenException(`Could not find disease view for id ${this.state.selectedDiseaseViewId}`);
        switch (selectedDiseaseView.type) {
            case dpViewType_MultivarAndValuesList:
                return _jsx(DPView_VariablesAndValues, { diseaseView: selectedDiseaseView });
            case dpViewType_MultivarList:
                return _jsx(Panel_MultiVarList, {});
            default:
                return _jsxs("div", { className: 'no-prop-message', children: ["No Implementation for type ", selectedDiseaseView.type] });
        }
    };
    render() {
        return _jsx(LL_V_L, { className: 'panel__disease-properties-data', children: this.renderPanelMain() });
    }
}
//# sourceMappingURL=Panel_DPView_ContentSelector.js.map